<div class="integrations-container">
    <div class="header">
        <div class="header-left">
            <h2>Integrations</h2>
            <p>Connect external platforms to enhance your CRM capabilities</p>
        </div>

        <button class="view-stats" (click)="openStatisticsPopup()">
            <mat-icon>bar_chart</mat-icon> View Stats
        </button>
    </div>

    <!-- Stats Row -->
    <div class="stats-grid">
        <div class="stat-card">
            <div>
                <div class="stat-label">Total Integrations</div>
                <div class="stat-value">4</div>
            </div>
            <div>
                <mat-icon class="blue-icon">dns</mat-icon>
            </div>
        </div>

        <div class="stat-card">
            <div>
                <div class="stat-value">4</div>
                <div class="stat-label">Active Connections</div>
            </div>
            <mat-icon class="green-icon">check_circle</mat-icon>
        </div>

        <div class="stat-card">
            <div>
                <div class="stat-value">1,247</div>
                <div class="stat-label">Messages Processed</div>
            </div>
            <mat-icon class="violet-icon">chat</mat-icon>
        </div>

        <div class="stat-card">
            <div>
                <div class="stat-value">16/8/2025</div>
                <div class="stat-label">Last Sync</div>
            </div>
            <mat-icon class="tangelo-icon">sync</mat-icon>
        </div>
    </div>

   
    <mat-tab-group>

        <!-- Overview Tab -->
        <mat-tab label="Overview">
            <div class="tab-content">
                <h3>Active Integrations</h3>
            </div>


            <!-- Integrations Grid -->
            <div class="integration-grid">
                <!-- Facebook -->
                <div class="integration-card">
                    <div class="card-header">
                        <mat-icon>facebook</mat-icon>
                        <div>
                            <div class="title">Facebook Pages</div>
                            <small>Connected 2024-01-15</small>
                        </div>
                        <span class="status-chip connected">Connected</span>
                    </div>
                    <div class="card-actions">
                        <button class="btn">Test</button>
                        <button class="btn"><mat-icon>sync</mat-icon> Sync</button>
                        <button class="icon-btn" (click)="openFacebookConfigDialog()"><mat-icon>settings</mat-icon></button>
                    </div>
                </div>

                <!-- WhatsApp -->
                <div class="integration-card">
                    <div class="card-header">
                        <mat-icon class="green-icon">phone</mat-icon>
                        <div>
                            <div class="title">WhatsApp Business</div>
                            <small>Connected 2024-01-16</small>
                        </div>
                        <span class="status-chip connected">Connected</span>
                    </div>
                    <div class="card-actions">
                        <button class="btn">Test</button>
                        <button class="btn"><mat-icon>sync</mat-icon> Sync</button>
                        <button class="icon-btn" (click)="openWhatsappConfig()"><mat-icon>settings</mat-icon></button>
                    </div>
                </div>

                <!-- Google Calendar -->
                <div class="integration-card">
                    <div class="card-header">
                        <mat-icon class="red-icon">calendar_today</mat-icon>
                        <div>
                            <div class="title">Google Calendar</div>
                            <small>Connected 2024-01-17</small>
                        </div>
                        <span class="status-chip connected">Connected</span>
                    </div>
                    <div class="card-actions">
                        <button class="btn">Test</button>
                        <button class="btn"><mat-icon>sync</mat-icon> Sync</button>
                        <button class="icon-btn" (click)="openGoogleCalendarConfig()"><mat-icon>settings</mat-icon></button>
                    </div>
                </div>

                <!-- Zoom -->
                <div class="integration-card">
                    <div class="card-header">
                        <mat-icon class="blue-icon">videocam</mat-icon>
                        <div>
                            <div class="title">Zoom Meetings</div>
                            <small>Connected 2024-01-18</small>
                        </div>
                        <span class="status-chip connected">Connected</span>
                    </div>
                    <div class="card-actions">
                        <button class="btn">Test</button>
                        <button class="btn"><mat-icon>sync</mat-icon> Sync</button>
                        <button class="icon-btn" (click)="openZoomConfigDialog()"><mat-icon>settings</mat-icon></button>
                    </div>
                </div>
            </div>

            <!-- Recent Activity -->
            <div class="recent-activity">
                <h3>Recent Activity</h3>
                <div class="activity-item">
                    <mat-icon class="success">check_circle</mat-icon>
                    <div class="details">
                        <div class="message">Facebook Pages connected successfully</div>
                        <small>2 hours ago</small>
                    </div>
                </div>

                <div class="activity-item">
                    <mat-icon class="info">sync</mat-icon>
                    <div class="details">
                        <div class="message">WhatsApp Business data synchronized</div>
                        <small>4 hours ago</small>
                    </div>
                </div>

                <div class="activity-item">
                    <mat-icon class="info">messages</mat-icon>
                    <div class="details">
                        <div class="message">15 new messages processed from Instagram</div>
                        <small>6 hours ago</small>
                    </div>
                </div>
            </div>
        </mat-tab> 

        <!-- Available Tab -->
        <mat-tab label="Available">
            <!-- <mat-icon class="blue-icon">facebook</mat-icon> -->
            <div class="integration-grid">
                <mat-card class="integration-card">
                    <mat-card-header>
                        <div class="card-header-content">
                            <div mat-card-avatar class="avatar-center">
                                <mat-icon class="blue-icon">facebook</mat-icon>
                            </div>
                            <div class="card-header-text">
                                <mat-card-title>Facebook Pages</mat-card-title>
                                <mat-card-subtitle>Connect Facebook Pages to capture leads from posts and
                                    ads</mat-card-subtitle>
                            </div>
                            <span class="status connected">Connected</span>
                        </div>

                    </mat-card-header>

                    <mat-card-content>
                        <strong>Features:</strong>
                    </mat-card-content>
                    <mat-card-content class="features-content">
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Lead capture</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Message sync</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Post engagement</div>
                    </mat-card-content>

                    <mat-card-actions>
                        <button mat-button color="primary" (click)="openFacebookConfigDialog()">Configure</button>
                        <button mat-stroked-button color="warn">Disconnect</button>
                    </mat-card-actions>
                </mat-card>



                <!-- WhatsApp Business -->
                <mat-card class="integration-card">
                    <mat-card-header>
                        <div class="card-header-content">

                            <div mat-card-avatar class="avatar-center">
                                <mat-icon class="green-icon">phone</mat-icon>
                            </div>

                            <div class="card-header-text">
                                <mat-card-title>WhatsApp Business</mat-card-title>
                                <div>Integrate WhatsApp Business API for messaging</div>

                            </div>
                            <div class="card-header-status">
                                <span class="status connected">Connected</span>
                            </div>
                        </div>
                    </mat-card-header>

                    <mat-card-content>
                        <strong>Features:</strong>
                    </mat-card-content>
                    <mat-card-content class="features-content">
                        

                        <div><mat-icon class="feature-check-icon">check</mat-icon> Business messaging</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Template messages</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Media sharing</div>

                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button color="primary" (click)="openWhatsappConfig()">Configure</button>
                        <button mat-stroked-button color="warn">Disconnect</button>
                        
                    </mat-card-actions>
                </mat-card>

                <!-- Google Workspace -->

                <mat-card class="integration-card">
                    <mat-card-header>
                        <div class="card-header-content">
                            <div mat-card-avatar class="avatar-center">
                                <mat-icon class="red-icon">calendar_today</mat-icon>
                            </div>
                            <div class="card-header-text">
                                <mat-card-title>Google Workspace</mat-card-title>
                                <div>Sync with Google Calendar and Gmail</div>
                            </div>
                            <div class="card-header-status">
                                <span class="status connected">Connected</span>
                            </div>
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <strong>Features:</strong>
                    </mat-card-content>
                    <mat-card-content class="features-content">

                        <div><mat-icon class="feature-check-icon">check</mat-icon> Calendar sync</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Gmail integration</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Contact sync</div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button color="primary" (click)="openGoogleCalendarConfig()">Configure</button>
                        <button mat-stroked-button color="warn">Disconnect</button>
                    </mat-card-actions>
                </mat-card>

                <!-- Zoom Meetings -->
                <mat-card class="integration-card">
                    <mat-card-header>
                        <div class="card-header-content">
                            <div mat-card-avatar class="avatar-center">
                                <mat-icon class="blue-icon">videocam</mat-icon>
                            </div>
                            <div class="card-header-text">
                                <mat-card-title>Zoom Meetings</mat-card-title>
                                <div>Automatically create and manage Zoom meetings</div>
                            </div>
                            <div class="card-header-status">
                                <span class="status connected">Connected</span>
                            </div>
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <strong>Features:</strong>
                    </mat-card-content>
                    <mat-card-content class="features-content">

                        <div><mat-icon class="feature-check-icon">check</mat-icon> Auto meeting creation</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Recording management</div>
                        <div><mat-icon class="feature-check-icon">check</mat-icon> Participant tracking</div>
                    </mat-card-content>

                    <mat-card-actions>
                        <button mat-button color="primary" (click)="openZoomConfigDialog()">Configure</button>
                        <button mat-stroked-button color="warn">Disconnect</button>
                        
                    </mat-card-actions>
                </mat-card>
            </div>
        </mat-tab>

        <!-- Connected Tab -->
        <mat-tab label="Connected">
            <div class="connected-tab-wrapper">

                <!-- One card per integration -->
                <mat-card class="integration-card" *ngFor="let integration of connectedIntegrations">
                    <div class="card-content">

                        <!-- Icon with background -->
                        <div class="integration-icon" [ngClass]="integration.colorClass">
                            <mat-icon>{{ integration.icon }}</mat-icon>
                        </div>

                        <!-- Text Content -->
                        <div class="integration-info">
                            <h3>{{ integration.name }}</h3>
                            <p>Connected on {{ integration.date }}</p>
                            <div class="badges">
                                <span class="badge connected">connected</span>
                                <span class="sync-status">
                                    <mat-icon class="check-icon">check_circle</mat-icon>
                                    Syncing</span>
                            </div>
                        </div>

                        <!-- Action buttons -->
                        <div class="integration-actions">
                            <button mat-stroked-button color="primary">Test Connection</button>
                            <button mat-icon-button color="primary" (click)="openSettingsDialog(integration.name)">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <button mat-icon-button color="warn">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                    </div>
                </mat-card>

            </div>
        </mat-tab>


        <!-- Settings Tab -->
       <mat-tab label="Settings">
  <div class="settings-wrapper">
    <div>
      <h3>Integration Settings</h3>
      <p class="subtitle">Configure global integration preferences</p>
    </div>

    <!-- Auto-sync toggle -->
    <div class="settings-section">
      <div class="setting-label">
        <strong>Auto-sync data</strong>
        <p>Automatically synchronize data from connected platforms</p>
      </div>
      <mat-slide-toggle class="custom-toggle" [(ngModel)]="autoSyncEnabled">
      </mat-slide-toggle>
    </div>

    <mat-divider></mat-divider>

    <!-- Real-time notifications toggle -->
    <div class="settings-section">
      <div class="setting-label">
        <strong>Real-time notifications</strong>
        <p>Receive instant notifications for integration events</p>
      </div>
      <mat-slide-toggle class="custom-toggle" [(ngModel)]="realTimeNotificationsEnabled">
      </mat-slide-toggle>
    </div>

    <mat-divider></mat-divider>

    <!-- Sync frequency dropdown -->
    <div class="settings-section">
      <div class="setting-label">
        <strong>Sync frequency</strong>
      </div>
      <mat-form-field appearance="fill" class="sync-dropdown">
        <mat-select [(ngModel)]="syncFrequency">
          <mat-option value="15">Every 15 minutes</mat-option>
          <mat-option value="30">Every 30 minutes</mat-option>
          <mat-option value="60">Every hour</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-divider></mat-divider>

    <!-- Data retention dropdown -->
    <div class="settings-section">
      <div class="setting-label">
        <strong>Data retention</strong>
      </div>
      <mat-form-field appearance="fill" class="retention-dropdown">
        <mat-select [(ngModel)]="dataRetention">
          <mat-option value="30">30 days</mat-option>
          <mat-option value="60">60 days</mat-option>
          <mat-option value="90">90 days</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</mat-tab>
